<template>
  <AppError />
</template>
